import VodCardList from "@/pages/vod-card"
import useDataApi from "@/hooks/useDataApi"

const Movie = ()=>{
    const [{dataResult, isLoading, isError}] = useDataApi({
        url: '/zhaopr/searchVod',
        typeId: 1,
        pageSize: 12,
        currentPage: 1
    })

    return(
        <>
            {isError && <div>ERROR!!!</div>}
            {isLoading ? <div>loading.....</div> :
                <div className="vod-movie">
                    <VodCardList vodResultList={dataResult} title={'电影'} />
                </div>
            }
        </>
    )
}
export default Movie;